<template>
<div>
    <PerfectScrollbar class="MaxWidthStylesheet">
        <div class="TopImageMaxWidthStylesheet">
          <div v-if="color" class="ShowOurIcon">
            <img src="../assets/img/lightL.jpg" alt="">
          </div>

          <div v-if="color1" class="ShowOurIcon">
            <img src="../assets/img/darkL.jpg" alt="">
          </div>

          <div style="position: absolute; left: 20px; top: 20px; z-index: 999999;" class="LanguageSwitcher">
            <VsxIcon @click="changeLanguage" iconName="Translate" :size="25" color="#000" type="linear" />
          </div>

          <div class="BottomTopImageMaxWidthStylesheet"></div>
          <div class="AnimationLoad">
            <div class="area" >
              <ul class="circles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div >
          </div>
        </div>

        <div v-if="ShowOnotherTab === 0" class="AllShowLogoInputAndLAbel">
            <form>
              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('register.fullName') }}</label>
                <div class="ShowAllNavBarStatus">
                  <input v-model="nameFamily" autocomplete="off" type="text" name="name">
                </div>
              </div>

              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('register.username') }}</label>
                <div class="ShowAllNavBarStatus">
                  <input onkeypress="return /[a-z , 0-9]/i.test(event.key)" autocomplete="off" @keyup="ShowButton" v-model="username" type="text" name="username">
                </div>
              </div>

              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('register.email') }}</label>
                <div class="ShowAllNavBarStatus">
                  <input onkeypress="return /[a-z , 0-9 , '.' , '_' ,'-','@']/i.test(event.key)" for="email" @keyup="ShowButton" @blur="validateEmail" v-model="email" type="email" name="email">
                  <div v-if="ShowTikEmail === true" class="ShowToOtherPeople">
                    <i class="icon-checkmark"></i>
                  </div>
                </div>
              </div>

              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('register.mobileNumber') }}</label>
                <div class="ShowAllNavBarStatus">
                  <input onkeypress="return /[۰-۹ , 0-9]/i.test(event.key)" minlength="0" maxlength="11" autocomplete="off" @keyup="ShowButton" v-model="number" type="text" name="number">
                </div>
              </div>

              <div v-if="numberTitle === true" class="ShowLogoInputAndLAbelCC">
                <span>{{ $t('login.errors.mobileNumberLength') }}</span>
                <div class="CercleShowLogoInputAndLAbel"></div>
              </div>

              <div class="ShowLogoInputAndLAbel">
                <label>{{ $t('register.referralCode') }}</label>
                <div class="ShowAllNavBarStatus">
                  <input v-model="moaref" autocomplete="off" type="text" name="code">
                </div>
              </div>

              <div @keyup="ShowButton" class="ShowLogoInputAndLAbel">
                <label>{{ $t('register.password') }}</label>
                <div class="ShowAllNavBarStatus23">
                  <input @keyup="ShowButton" autocomplete="off" v-model="password" :type="passwordFild1" name="password">
                  <div @click="ClickToShowDarkred1" class="ClickToShowTextPassword">
                    <svg v-if="passwordFild1 === 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512">
                      <g>
                        <g>
                          <path d="m251.6,185.7c-36.9,0-67,31.5-67,70.3 0,38.7 30,70.3 67,70.3 36.9,0 67-31.5 67-70.3 0-38.7-30.1-70.3-67-70.3z"/>
                          <path d="m251.6,367.1c-59.4,0-107.8-49.8-107.8-111.1 0-61.3 48.4-111.1 107.8-111.1s107.8,49.8 107.8,111.1c0,61.3-48.4,111.1-107.8,111.1zm246.3-121.9c-63.8-102.4-149.8-158.8-241.9-158.8-92.1,0-178.1,56.4-241.9,158.8-4.1,6.6-4.1,15 0,21.6 63.8,102.4 149.8,158.8 241.9,158.8 92.1,0 178-56.4 241.9-158.8 4.1-6.6 4.1-15 0-21.6z"/>
                        </g>
                      </g>
                    </svg>

                    <svg v-if="passwordFild1 !== 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M11.859 9h0.141c1.641 0 3 1.359 3 3v0.188zM7.547 9.797c-0.328 0.656-0.563 1.406-0.563 2.203 0 2.766 2.25 5.016 5.016 5.016 0.797 0 1.547-0.234 2.203-0.563l-1.547-1.547c-0.188 0.047-0.422 0.094-0.656 0.094-1.641 0-3-1.359-3-3 0-0.234 0.047-0.469 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266c-1.124-1.11-2.256-2.213-3.375-3.328-1.359 0.563-2.813 0.844-4.359 0.844-5.016 0-9.281-3.094-11.016-7.5 0.797-1.969 2.109-3.656 3.75-4.969-0.914-0.914-1.812-1.844-2.719-2.766zM12 6.984c-0.656 0-1.266 0.141-1.828 0.375l-2.156-2.156c1.219-0.469 2.578-0.703 3.984-0.703 5.016 0 9.234 3.094 10.969 7.5-0.75 1.875-1.922 3.469-3.422 4.734l-2.906-2.906c0.234-0.563 0.375-1.172 0.375-1.828 0-2.766-2.25-5.016-5.016-5.016z"/>
                    </svg>
                  </div>
                </div>
              </div>

              <div style="margin-top: 20px" class="ShowLogoInputAndLAbel">
                <label>{{ $t('register.confirmPassword') }}</label>
                <div class="ShowAllNavBarStatus23">
                  <input @keyup="ShowButton" autocomplete="off" v-model="password2" :type="passwordFild" name="password">
                  <div @click="ClickToShowDarkred" class="ClickToShowTextPassword">
                    <svg v-if="passwordFild === 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512">
                      <g>
                        <g>
                          <path d="m251.6,185.7c-36.9,0-67,31.5-67,70.3 0,38.7 30,70.3 67,70.3 36.9,0 67-31.5 67-70.3 0-38.7-30.1-70.3-67-70.3z"/>
                          <path d="m251.6,367.1c-59.4,0-107.8-49.8-107.8-111.1 0-61.3 48.4-111.1 107.8-111.1s107.8,49.8 107.8,111.1c0,61.3-48.4,111.1-107.8,111.1zm246.3-121.9c-63.8-102.4-149.8-158.8-241.9-158.8-92.1,0-178.1,56.4-241.9,158.8-4.1,6.6-4.1,15 0,21.6 63.8,102.4 149.8,158.8 241.9,158.8 92.1,0 178-56.4 241.9-158.8 4.1-6.6 4.1-15 0-21.6z"/>
                        </g>
                      </g>
                    </svg>

                    <svg v-if="passwordFild !== 'text'" width="19" height="19" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M11.859 9h0.141c1.641 0 3 1.359 3 3v0.188zM7.547 9.797c-0.328 0.656-0.563 1.406-0.563 2.203 0 2.766 2.25 5.016 5.016 5.016 0.797 0 1.547-0.234 2.203-0.563l-1.547-1.547c-0.188 0.047-0.422 0.094-0.656 0.094-1.641 0-3-1.359-3-3 0-0.234 0.047-0.469 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266c-1.124-1.11-2.256-2.213-3.375-3.328-1.359 0.563-2.813 0.844-4.359 0.844-5.016 0-9.281-3.094-11.016-7.5 0.797-1.969 2.109-3.656 3.75-4.969-0.914-0.914-1.812-1.844-2.719-2.766zM12 6.984c-0.656 0-1.266 0.141-1.828 0.375l-2.156-2.156c1.219-0.469 2.578-0.703 3.984-0.703 5.016 0 9.234 3.094 10.969 7.5-0.75 1.875-1.922 3.469-3.422 4.734l-2.906-2.906c0.234-0.563 0.375-1.172 0.375-1.828 0-2.766-2.25-5.016-5.016-5.016z"/>
                    </svg>
                  </div>
                </div>
              </div>

              <div v-if="passwordOff" class="ShowLogoInputAndLAbelCC">
                <span>{{ $t('login.errors.passwordMismatch') }}</span>
                <div class="CercleShowLogoInputAndLAbel"></div>
              </div>

              <div @click="onShow" class="ShowLogoInputAndLAbel23">
                {{ $t('register.sendCode') }}
              </div>

              <router-link to="/login" class="ShowTextForCreateAccount">
                <div>{{ $t('register.login') }}</div>
                <span>{{ $t('register.haveAccount') }}</span>
              </router-link>
            </form>
        </div>

        <div v-if="ShowOnotherTab === 1" class="AllShowLogoInputAndLAbel">
            <div class="TopTitleAllShowLogoInputAndLAbel">
                {{ $t('register.verificationMethod.title') }}
            </div>
            <div class="ShowSendMessageSelectAllShowLogoInputAndLAbel">
                <div @click="sendSmsCode('mobile')" class="ChildShowSendMessageSelectAllShowLogoInputAndLAbel">
                    <p>{{number}}</p>
                    <span>{{ $t('register.verificationMethod.mobileOption') }}</span>
                </div>
                <div @click="sendSmsCode('email')" class="ChildShowSendMessageSelectAllShowLogoInputAndLAbel">
                    <p>{{email}}</p>
                    <span>{{ $t('register.verificationMethod.emailOption') }}</span>
                </div>
            </div>

            <div style="direction: rtl" class="TabAllShowLogoInputAndLAbelSendCode">
                <div class="ShowNotesTabAllShowLogoInputAndLAbelSendCode">
                    <span>1 : </span>
                    <p>{{ $t('register.verificationMethod.notes.note1') }}</p>
                </div>

                <div class="ShowNotesTabAllShowLogoInputAndLAbelSendCode">
                    <span>2 : </span>
                    <p>{{ $t('register.verificationMethod.notes.note2') }}</p>
                </div>

                <div class="ShowNotesTabAllShowLogoInputAndLAbelSendCode">
                    <span>3 : </span>
                    <p>{{ $t('register.verificationMethod.notes.note3') }}</p>
                </div>

                <div class="ShowNotesTabAllShowLogoInputAndLAbelSendCode">
                    <span>4 : </span>
                    <p>{{ $t('register.verificationMethod.notes.note4') }}</p>
                </div>

                <div style="margin-bottom: 0" class="ShowNotesTabAllShowLogoInputAndLAbelSendCode">
                    <span>5 : </span>
                    <p>{{ $t('register.verificationMethod.notes.note5') }}</p>
                </div>
            </div>
        </div>

        <div v-if="ShowOnotherTab === 2" class="AllShowLogoInputAndLAbel">
            <div class="TopTitleAllShowLogoInputAndLAbel">
                {{ $t('register.enterCode') }}
            </div>

            <div class="InputAllShowLogoInputAndLAbelSend">
                <input onkeypress="return /[۰-۹ , 0-9]/i.test(event.key)" :style="styleCode" minlength="0" maxlength="6" type="text" v-model="codeSend" name="code" @keyup="CodeSendCode" :placeholder="$t('register.enterCode')">
            </div>

            <div v-if="ShowErrCode === true" class="ShowLogoInputAndLAbelCC">
                <span>{{ $t('login.errors.invalidCode') }}</span>
                <div class="CercleShowLogoInputAndLAbel"></div>
            </div>
        </div>

        <div v-if="ShowOnotherTab === 3" class="AllShowLogoInputAndLAbel">
            <div class="TopTitleAllShowLogoInputAndLAbel">
                {{ $t('register.setupProfile.title') }}
            </div>
            <form autocomplete="off" action="/user_edit" method="post">
                <input type="hidden" name="_token" v-bind:value="csrf_token">
                <input name="number" type="hidden" :value="number">

                <div class="ShowLogoInputAndLAbelImg">
                    <v-card width="auto">
                        <div class="example">
                            <cropper ref="cropper" class="example-cropper" :src="img" />
                            <drop-zone
                                v-model="img"
                                :label="upload"
                                :location="location"
                                @uploaded="newImagesUploaded"
                                class="pb-15"
                            />
                            <div class="button-wrapper">
                                <span class="button" @click="cropImage">Crop image</span>
                            </div>
                        </div>
                    </v-card>

                </div>

                <div class="ShowLogoInputAndLAbel">
                    <input type="file" @change="previewFiles">
                </div>

                <div class="ShowLogoInputAndLAbel">
                    <label>{{ $t('register.setupProfile.fullName') }}</label>
                    <div class="ShowAllNavBarStatus">
                        <input name="name" type="text">
                    </div>
                </div>

                <div class="ShowLogoInputAndLAbel">
                    <label>{{ $t('register.setupProfile.bio') }}</label>
                    <div class="ShowAllNavBarStatus">
                        <textarea name="bio"></textarea>
                    </div>
                </div>

                <div class="ShowLogoInputAndLAbel5434">
                  {{ $t('register.setupProfile.submit') }}
                </div>
            </form>
        </div>

      <Vcode 
        :show="isShow" 
        @success="onSuccess"
        @close="onClose"
        successText="تایید شد!"
        failText="تایید نشد، لطفا دوباره تلاش کنید"
        sliderText=" تکمیل تایید"
        />
    </PerfectScrollbar>
</div>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import {mapActions} from "vuex";
import {toast} from "vue3-toastify";
import Vcode from 'vue3-puzzle-vcode';
import axios from "@/axios";

export default {
    name: "registerUser",
    components: {
      Vcode,
      Cropper,
      PerfectScrollbar
    },
    props : ['csrf_token'],
    data(){
        return{
            ShowOnotherTab : 0,
            isShow: false,

            BoxShow : false,
            passwordOff : false,
            passwordOffTwo : false,
            emailOn : false,
            ShowTikPas2 : '',
            ShowTikEmail : '',
            moaref : this.$route.query.code,
            ShowErr: '90',
            errorMessage: '',
            username : '',
            email : '',
            password : '',
            password2 : '',
            nameFamily : '',
            numberTitle : '',
            upload : '',
            number : '',
            newImagesUploaded : '',
            styleNavBar : '',
            passwordFild : 'password',
            passwordFild1 : 'password',

            UserAlarm : false,
            ShowErrCode : false,
            UserCount : '',
            EmailCount : '',
            NumberCount : '',
            ShowTikEmailOn : '',
            styleCode : '',
            NumberCheck : '',
            NumberAlarm : '',
            codeSend : '',

            UserLength : 0,
            NumberLength : 0,
            EmailLength : 0,

            img: '',

          color : false,
          color1 : false,

          codeSms : '',
          Counter : 0,
        }
    },
    computed: {
        currentLang() {
            return this.$store.state.currentLang;
        },
        theme() {
            return this.$store.state.theme;
        }
    },
    methods:{
      ...mapActions(['register']),

      onShow() {
        this.isShow = true;
      },
      onClose() {
        this.isShow = false;
      },
      async onSuccess() {
        this.onClose();


        let attempts = 0;
        const maxAttempts = 10;
        const delay = 1000;

        while (attempts < maxAttempts) {
          try {
            const response = await axios.post('/check-auth', {
              nameFamily: this.nameFamily,
              username: this.username,
              email: this.email,
              mobile: this.number,
              moaref: this.moaref,
              password: this.password,
              password2: this.password2,
            });

            if (response.data === "success"){
              this.ShowOnotherTab = 1
            }

            return
          } catch (error) {
            if (error.response) {
              const errors = error.response.data.errors;

              const keys = Object.keys(errors);
              for (const key of keys) {
                toast(errors[key].join(', '), {
                  autoClose: 3000,
                  position: "top-right",
                  type: "error",
                });
              }
              return;
            } else {
              console.error('An unexpected error occurred:', error.message);
              toast(this.$t('common.error'), {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }

          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }


      },
      async ClickMethods(){
        try {
          const resposnse = await this.register({
            nameFamily: this.nameFamily,
            username: this.username,
            email: this.email,
            mobile: this.number,
            moaref: this.moaref,
            password: this.password,
            password2: this.password2,
            type: this.codeSms,
            code: this.codeSend,
          });

          if (resposnse == "code"){
            toast(this.$t('login.errors.invalidCode'), {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
            return;
          }

          if (resposnse[0] == 'success'){
            this.$router.push({ name: 'IndexUser' });
          }


        } catch (error) {
          if (error.response) {
            const errors = error.response.data.errors;
            const keys = Object.keys(errors);
            for (const key of keys) {
              toast(errors[key].join(', '), {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          } else {
            console.error('An unexpected error occurred:', error.message);
            toast(this.$t('common.error'), {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          }
        }
      },
      previewFiles(event) {
            for (const item of event.target.files) {
                this.img = item.name;
                console.log(item.name);
            }
            console.log(event);
        },
      ClickToShowDarkred () {
            if(this.passwordFild === 'password'){
                this.passwordFild = 'text'
            }else {
                this.passwordFild = 'password'
            }
        },
      ClickToShowDarkred1 () {
            if(this.passwordFild1 === 'password'){
                this.passwordFild1 = 'text'
            }else {
                this.passwordFild1 = 'password'
            }
        },
      showScore (score) {
            this.ShowErr = score;
        },
      ShowButton(){
            if (this.username === ''){
                this.UserAlarm = false
            }

            if (this.number === ''){
                this.numberTitle = false
                this.NumberCheck = ''
            }

            if (this.username.length !== this.UserLength){
                if (this.username !== ''){
                    if (this.username.length <= 4){
                        this.UserAlarm = true;
                        this.UserCount = '';
                        this.UserLength = 0;
                    }else {
                        this.UserAlarm = false;
                        this.UserCount = 0;


                    }
                }else {
                    this.UserAlarm = false;
                    this.UserCount = '';
                }
            }


            if (this.number.length !== this.NumberLength){
                if (this.number != ''){
                        if (this.number.length < 11){
                            this.NumberCheck = false;
                            this.NumberLength = 0;
                            this.NumberCount = true;
                            this.numberTitle = true;
                        }else {
                            this.NumberCheck = true;
                            this.NumberCount = 0;
                            this.numberTitle = false;

                        }
                }else {
                    this.NumberCheck = '';
                    this.numberTitle = false;
                    this.NumberCount = '';
                }
            }

            if (this.password != ''){
                if (this.password.length < 7){
                    this.passwordOffTwo = true
                }else{
                    this.passwordOffTwo = false
                }
            }else{
                this.passwordOffTwo = false
                this.ShowErr = 10
            }

            if (this.password != ''){
                if (this.password2 != ''){
                    if (this.password !== this.password2){
                        this.passwordOff = true
                        this.styleNavBar = 'background: red'
                        this.ShowTikPas2 = false
                    }else{
                        this.passwordOff = false
                        this.styleNavBar = 'background: #008000'
                        this.ShowTikPas2 = true
                    }
                }
            }


            if (this.UserCount === false){
                if (this.ShowTikEmailOn === false){
                    if (this.NumberCount === false){

                    if (this.ShowErr >= 2){

                        if (this.password === this.password2){
                            this.BoxShow = true
                        }else {
                            this.BoxShow = false
                        }
                    }else {
                        this.BoxShow = false
                    }

                }else {
                    this.BoxShow = false
                }

                }else {
                    this.BoxShow = false
                }
            }else {
                this.BoxShow = false
            }
        },
      onSubmit(event) {
            event.preventDefault()
            console.log(event)
        },
      cropImage() {
            console.log('111')
            // const result = this.$refs.cropper.getResult();
            // const newTab = window.open();
            // for testing open the result in a new tab
            // newTab.document.body.innerHTML = `<img src="${result.canvas.toDataURL(
            //     "image/jpeg"
            // )}"></img>`;
        },
      validateEmail(email) {
            if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
                this.errorMessage = '';
                this.emailOn = true;
                this.ShowTikEmail = true;
            } else {
                this.errorMessage = this.$t('login.errors.invalidEmail');
                this.emailOn = false;
                this.ShowTikEmail = false;
                this.ShowTikEmailOn = false;
            }

            if (email === '') {
                this.errorMessage = '';
                this.emailOn = false;
                this.ShowTikEmail = false;
            }
        },
      async sendSmsCode(value){
        this.ShowOnotherTab = 2
        this.codeSms = value

        let attempts = 0;
        const maxAttempts = 10;
        const delay = 1000;

          while (attempts < maxAttempts) {
            try {
              const response = await axios.post('/create-code', {
                type : value,
                number: this.number,
                email: this.email,
              });

              if (response !== "wrong") {
                console.log(this.$route);
                // this.$router.push({ path: '/' });
                this.ShowDetails = false;
                return;
              } else {
                this.ShowDetails = true;
                return;
              }
            } catch (error) {
              this.ShowDetails = true;
            }

            attempts++;
            await new Promise(resolve => setTimeout(resolve, delay));
          }
      },
      CodeSendCode(){
        if (this.codeSend.length == 6){
          if (this.Counter == 0){
            this.ClickMethods()
            this.Counter = 1
            console.log(this.codeSend.length , this.Counter)
          }
        }else {
          this.Counter = 0;
        }
      },
      loadTheme() {
        const savedTheme = localStorage.getItem('theme');
        if(savedTheme == "light"){
          this.color = true
          this.color1 = false
        }else{
          this.color = false
          this.color1 = true
        }
      },
      changeLanguage() {
        const newLang = this.currentLang === 'fa' ? 'en' : 'fa';
        this.$store.dispatch('changeLanguage', newLang);

        this.$i18n.locale = newLang;

        document.documentElement.dir = newLang === 'fa' ? 'rtl' : 'ltr';
        document.body.dir = newLang === 'fa' ? 'rtl' : 'ltr';
      },
      loadLanguage() {
        this.$i18n.locale = this.currentLang;
        document.documentElement.dir = this.currentLang === 'fa' ? 'rtl' : 'ltr';
        document.body.dir = this.currentLang === 'fa' ? 'rtl' : 'ltr';
      },
    },
    watch: {
        email(value){
            this.email = value;
            this.validateEmail(value);
        }
    },
    mounted(){
        this.showScore()
        this.loadLanguage();
        this.loadTheme()
        setInterval(() => {
          this.loadTheme()
        }, 100);
    }
}
</script>

<style scoped>

.example-cropper {
    border: solid 1px #eee;
    width: 100%;
}

.button-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 17px;
}

.button {
    color: white;
    font-size: 16px;
    padding: 10px 20px;
    background: #35b392;
    cursor: pointer;
    transition: background 0.5s;
    font-family: Open Sans, Arial;
    margin: 0 10px;
}

.button:hover {
    background: #38d890;
}

.button input {
    display: none;
}

</style>
